import { type CommonErrorResponses as LinkCommonErrorResponses } from '../links/CommonErrorResponses';
import { type PreviewPageContextRequest as SchemaPreviewPageContextRequest } from '../schemas/PreviewPageContextRequest';
import { type PreviewPageContextResponse as SchemaPreviewPageContextResponse } from '../schemas/PreviewPageContextResponse';

/**
 * ‼️ Файл сформирован автоматически. Не редактировать вручную.
 *
 * @tags Pages
 */
export const GetPageContextContentType = 'application/json' as const;
export type GetPageContextRequest = SchemaPreviewPageContextRequest;
export type GetPageContextResponses = LinkCommonErrorResponses & {
    /**
     * @description Preview page context for constructor
     */
    '200': {
        'application/json': SchemaPreviewPageContextResponse;
    };
};
export type GetPageContextResponseSuccess = GetPageContextResponses['200']['application/json'];
export type GetPageContextSearchParams = undefined;
export type GetPageContextPathParameters = undefined;
export const GetPageContextUrl = '/pages/context' as const;
export const GetPageContextMethod = 'POST' as const;
export const getGetPageContextUrl = (_params?: GetPageContextPathParameters) => GetPageContextUrl;
